/**
 * useTopics Hook
 *
 * Custom hook for managing topic data and operations.
 * Provides queries and mutations for topic management.
 */

import { useQuery, useMutation } from 'convex/react';
import { useCallback } from 'react';
import { api } from '../../convex/_generated/api';
import { Id } from '../../convex/_generated/dataModel';

/**
 * Hook for managing topics data and operations
 */
export const useTopics = () => {
  // Query for all user's topics
  const topics = useQuery(api.topics.getMyTopics, {});

  // Mutation for deleting topics
  const deleteTopicMutation = useMutation(api.topics.deleteTopic);

  /**
   * Delete a topic by ID
   */
  const deleteTopic = useCallback(
    async (topicId: Id<'topics'>) => {
      await deleteTopicMutation({ topicId });
    },
    [deleteTopicMutation]
  );

  return {
    topics,
    isLoading: topics === undefined,
    deleteTopic,
  };
};
